// TODO: Zjednotit s notification modal - vela veci je repetitivnych
import React, {useEffect, useState} from 'react';
import {Button, Modal} from 'react-bootstrap';
import {
	ComponentUtils,
	DetailActions,
	notification,
	post,
	SwEmbeddedDetail,
	SwExitButton,
	SwForm
} from 'simplifyworks-core-ui';
import i18n from 'i18next';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {FaEye} from 'react-icons/fa';
import NotificationOrMessagePreviewModal from './NotificationOrMessagePreviewModal';
import {getElementAfter} from '../../utils';

const MessageModal = (props) => {
	const [showPreviewModal, setShowPreviewModal] = useState(false);
	const [previewModalData, setPreviewModalData] = useState(null);

	useEffect(() => {
		if (props?.show) {
			post(
				'/api/foedus/organ-offer/message-recipients',
				{entryId: props?.entryId},
				(recipientEmailsResponse) => {
					setPreviewModalData({
						...previewModalData,
						recipientEmails: recipientEmailsResponse
					});
				},
				(err) => {
					notification.showLocalizedMessage({
						level: 'error',
						autoDismiss: 0,
						messageKey: err.data.messageKey
					});
				}
			);
		}
	}, [props?.show]);

	const confirmModal = () => {
		post(
			'/api/foedus/organ-offer/create-message',
			{
				userNotificationContent: props.messageFormData.body,
				emails: previewModalData.recipientEmails,
				entryId: props.entryId
			},
			() => {
				notification.showLocalizedMessage({
					level: 'success',
					autoDismiss: 10,
					titleKey: 'foedus-notification-create-success-title',
					messageKey: 'foedus-notification-create-success-message'
				});

				props.actions.detail.formInit(
					'/api/foedus/organ-offer/message/new',
					'DEFAULT'
				);
				setShowPreviewModal(false);
				props.close();
				props?.actions?.detail?.load(
					'/api/ood/entries/' + props?.entryId,
					'history'
				);
			},
			(err) => {
				notification.showLocalizedMessage({
					level: 'error',
					autoDismiss: 0,
					messageKey: err.data.messageKey
				});
			}
		);
	};

	const preview = () => {
		post(
			'/api/foedus/organ-offer/' + props.entryId + '/preview',
			{
				body: props.messageFormData.body,
				recipients: []
			},
			(response) => {
				if (previewModalData?.recipientEmails?.length === 0) {
					notification.showLocalizedMessage({
						level: 'error',
						titleKey: 'foedus-message-no-recipients-title',
						messageKey: 'foedus-message-no-recipients-message',
						autoDismiss: 0
					});
				} else {
					setPreviewModalData({
						...response,
						recipientEmails: previewModalData?.recipientEmails
					});
					setShowPreviewModal(true);
				}
			},
			(err) => {
				notification.showLocalizedMessage({
					level: 'error',
					autoDismiss: 0,
					messageKey: err.data.messageKey
				});
			}
		);
	};

	return (
		<>
			<Modal
				show={props.show}
				onHide={() => props.close()}
				size={'xl'}
			>
				<Modal.Header closeButton>
					<Modal.Title style={{width: 'auto'}}>
						{i18n.t('foedus-message-title')}
					</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<SwEmbeddedDetail
						name='message'
						rest='/api/foedus/organ-offer/message'
						restId={'new'}
						tabName={''}
						hideButtons
						newCallback={(actionResult, id, errorResponse) => {
							if (!errorResponse) {
								props.close();
								window.location.reload();
							}
						}}
					>
						<SwForm
							name='message'
							rest={''}
							labelKey='foedus-organ-offer-info'
						>
							<SwForm.Section>
								<SwForm.String
									type='area'
									rows={10}
									size={12}
									property='body'
									labelKey='foedus-message-body'
									validations='required;length(2000)'
								/>
							</SwForm.Section>

						</SwForm>
					</SwEmbeddedDetail>
				</Modal.Body>

				<Modal.Footer>
					<SwExitButton onClick={() => {
						setShowPreviewModal(false);
						props.close();
					}}/>
					<Button
						variant='primary'
						onClick={() => preview()}
						disabled={props?.messageFormData?.body?.length > 2000}
					>
						<FaEye/>{' ' + i18n.t('foedus-message-previewBtn')}
					</Button>
				</Modal.Footer>
			</Modal>

			{showPreviewModal ?
				<NotificationOrMessagePreviewModal
					show={showPreviewModal}
					data={previewModalData}
					title={i18n.t('foedus-notification-preview')}
					confirmModalFn={confirmModal}
					closeModalFn={() => setShowPreviewModal(false)}
					isMessage
				/> : null}
		</>

	);
};

const mapDispatchToProps = (dispatch) => ({
	actions: {
		detail: bindActionCreators(DetailActions, dispatch)
	}
});

const mapStateToProps = (state, ownProps) => {
	const messageFormData = ComponentUtils.getFormData(state, '/api/foedus/organ-offer/message/new', 'DEFAULT');
	const pathSegments = state?.router?.location?.pathname?.split('/') || [];

	return {
		loggedUserPrimaryFoedusRole: state?.foedus?.loggedUserPrimaryFoedusRole,
		messageFormData,
		entryId: getElementAfter(pathSegments, 'entries'),
		definitionId: getElementAfter(pathSegments, 'definition')
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(MessageModal);
